var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.avatarUrl,"alt":"foto de perfil","width":_vm.size,"height":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }